module.exports = __webpack_public_path__ + "img/bb_g1_t_nose-04.fcebc712.svg";